import { Enum } from "./Enum";

export const E_FEATURE = Object.freeze({
  MAIN: "/feature",
  USER_FEATURE: "/user-feature",
});

export type E_FEATURE = Enum<typeof E_FEATURE>;
